import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { buildCanonicalUrl } from "lib/seo";

import NewsletterHubView from "content-ui/newsletters";
import Navigation from "components/navigation/navigation";
import Footer from "components/footer/footer";
import ErrorBoundary from "components/errorBoundary/errorBoundary";
import { fetchNavbarAndFooter } from "lib/fetchers/common";
import { fetchNewslettersPage } from "content-ui/newsletters/fetcher";

export async function getServerSideProps({ res }) {
  const [menuItems, pageData] = await Promise.all([
    fetchNavbarAndFooter(),
    fetchNewslettersPage(),
  ]);

  res.setHeader(
    "Cache-Control",
    "public, s-maxage=10, stale-while-revalidate=59"
  );

  return {
    props: {
      __initialState: {
        sitewideOption: { ...menuItems },
      },
      pageData,
    },
  };
}

const NewsletterHubPage = (props) => {
  const title = props?.pageData?.seo?.title || "Newsletters | Sifted";
  const description =
    props?.pageData?.seo?.description ||
    "Swiftly in your inbox, discover all the newsletters Sifted offers.";
  const seoImage =
    props?.pageData?.seo?.image?.url ||
    "https://images.sifted.eu/wp-content/uploads/2023/05/11175021/newsletters.jpg?auto=format,compress&q=75&w=1200";

  return (
    <>
      <Head>
        {generateNextSeo({
          title: title,
          description: description,
          canonical: buildCanonicalUrl("/newsletters"),
          openGraph: {
            title: title,
            description: description,
            images: [{ url: seoImage }],
          },
          twitter: {
            handle: "@siftedeu",
            site: "@siftedeu",
            cardType: "summary_large_image",
          },
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Navigation />
      <ErrorBoundary>
        <NewsletterHubView data={props.pageData} />
      </ErrorBoundary>
      <Footer />
    </>
  );
};

export default NewsletterHubPage;
